// src/components/Inspector.jsx
import React from 'react';
import './Inspector.css';
import PropTypes from 'prop-types';
import RichTextToolbar from './RichTextToolbar';

function Inspector({ block, onUpdate, onUpdateArray, onDelete }) {
  if (!block) {
    return (
      <div className="inspector">
        <div className="inspector-header">
          <h3>Propriétés</h3>
          <p>Cliquez sur un bloc</p>
        </div>
        <div className="inspector-content">
          <div className="empty-inspector">
            <p>Sélectionnez un bloc pour l&apos;éditer</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="inspector">
      <div className="inspector-header">
        <h3>Propriétés</h3>
        <p>
          {block.type} #{block.id.slice(-4)}
        </p>
      </div>
      <div className="inspector-content">
        {block.type === 'heading' && (
          <>
            <RichTextToolbar block={block} onUpdate={onUpdate} />
            <div className="form-group">
              <label>Niveau</label>
              <select
                value={block.level || 'h2'}
                onChange={(e) => onUpdate({ level: e.target.value })}
              >
                <option value="h1">H1</option>
                <option value="h2">H2</option>
                <option value="h3">H3</option>
              </select>
            </div>
            <div className="form-group">
              <label>Contenu</label>
              <input
                type="text"
                value={block.content}
                onChange={(e) => onUpdate({ content: e.target.value })}
              />
            </div>
          </>
        )}

        {block.type === 'paragraph' && (
          <>
            <RichTextToolbar block={block} onUpdate={onUpdate} />
            <div className="form-group">
              <label>Texte</label>
              <textarea
                value={block.content}
                onChange={(e) => onUpdate({ content: e.target.value })}
              />
            </div>
          </>
        )}

        {block.type === 'richtext' && (
          <>
            <RichTextToolbar block={block} onUpdate={onUpdate} />
            <div className="form-group">
              <label>Contenu HTML</label>
              <textarea
                value={block.content}
                onChange={(e) => onUpdate({ content: e.target.value })}
                rows={8}
              />
            </div>
          </>
        )}

        {block.type === 'button' && (
          <>
            <div className="form-group">
              <label>Texte</label>
              <input
                type="text"
                value={block.label || ''}
                onChange={(e) => onUpdate({ label: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Lien</label>
              <input
                type="text"
                value={block.link || ''}
                placeholder="https://..."
                onChange={(e) => onUpdate({ link: e.target.value })}
              />
            </div>
          </>
        )}

        {block.type === 'image' && (
          <>
            <div className="form-group">
              <label>URL</label>
              <input
                type="text"
                value={block.url || ''}
                placeholder="https://..."
                onChange={(e) => onUpdate({ url: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Texte alternatif</label>
              <input
                type="text"
                value={block.alt || ''}
                onChange={(e) => onUpdate({ alt: e.target.value })}
              />
            </div>
          </>
        )}

        {block.type === 'features' && (
          <div className="form-group">
            <label>Éléments (un par ligne)</label>
            <textarea
              value={(block.items || []).join('\n')}
              onChange={(e) =>
                onUpdate({
                  items: e.target.value.split('\n').filter((v) => v.trim()),
                })
              }
            />
          </div>
        )}

        {block.type === 'stats' && (
          <div className="form-group">
            <label>Statistiques</label>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {(block.items || []).map((stat, i) => (
                <div
                  key={i}
                  style={{
                    marginBottom: '12px',
                    padding: '12px',
                    background: 'white',
                    borderRadius: '4px',
                  }}
                >
                  <div className="form-group" style={{ marginBottom: '8px' }}>
                    <label>Valeur</label>
                    <input
                      type="text"
                      value={stat.value}
                      onChange={(e) =>
                        onUpdateArray('items', i, {
                          ...stat,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Label</label>
                    <input
                      type="text"
                      value={stat.label}
                      onChange={(e) =>
                        onUpdateArray('items', i, {
                          ...stat,
                          label: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {block.type === 'contact' && (
          <div className="form-group">
            <label>Contacts</label>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {(block.contacts || []).map((contact, i) => (
                <div
                  key={i}
                  style={{
                    marginBottom: '12px',
                    padding: '12px',
                    background: 'white',
                    borderRadius: '4px',
                  }}
                >
                  <div className="form-group" style={{ marginBottom: '8px' }}>
                    <label>Nom</label>
                    <input
                      type="text"
                      value={contact.name}
                      onChange={(e) =>
                        onUpdateArray('contacts', i, {
                          ...contact,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: '8px' }}>
                    <label>Titre</label>
                    <input
                      type="text"
                      value={contact.title}
                      onChange={(e) =>
                        onUpdateArray('contacts', i, {
                          ...contact,
                          title: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: '8px' }}>
                    <label>Email</label>
                    <input
                      type="email"
                      value={contact.email}
                      onChange={(e) =>
                        onUpdateArray('contacts', i, {
                          ...contact,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Téléphone</label>
                    <input
                      type="text"
                      value={contact.phone}
                      onChange={(e) =>
                        onUpdateArray('contacts', i, {
                          ...contact,
                          phone: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {block.type === 'download' && (
          <>
            <div className="form-group">
              <label>Titre</label>
              <input
                type="text"
                value={block.title || ''}
                onChange={(e) => onUpdate({ title: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={block.description || ''}
                onChange={(e) => onUpdate({ description: e.target.value })}
              />
            </div>
          </>
        )}

        <div className="form-actions">
          <button className="btn-delete" onClick={onDelete}>
            🗑️ Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}
Inspector.propTypes = {
  block: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string.isRequired,
    level: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    items: PropTypes.array,
    contacts: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        title: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
      })
    ),
    label: PropTypes.string,
    link: PropTypes.string,
    url: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  onUpdate: PropTypes.func.isRequired,
  onUpdateArray: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default Inspector;
